import { createContext, Dispatch } from 'react';
import { PackageType } from '../../api/package';
import { CartActionType } from './actions';

export type CartStateType = PackageType[];

export const CartContext = createContext<CartStateType>([]);
export const CartDispatchContext = createContext<Dispatch<ReturnType<CartActionType>> | null>(null);
